interface weekDaysType {
  [key: string]: string;
}
interface objInfo {
  [key: string]: any;
}

function mapToList(obj: objInfo) {
  return Object.keys(obj).map((key: string) => {
    return {
      id: Number(key),
      nameCn: obj[key],
    };
  });
}

// 车类型：1-单程，2-往返
export const enumerationTripTypeList = [
  {
    id: 1,
    nameCn: "单程",
  },
  {
    id: 2,
    nameCn: "往返",
  },
] as const;
// 包车类型：2-大车，0-小车，1-包车
export const enumerationAllCharteredList: objInfo[] = [
  {
    id: 2,
    nameCn: "大车",
  },
  {
    id: 0,
    nameCn: "小车",
  },
  {
    id: 1,
    nameCn: "包车",
  },
];
// 车型：1-大车，2-小车
export const enumerationCarTypeList: objInfo[] = [
  {
    id: 1,
    nameCn: "大车",
  },
  {
    id: 2,
    nameCn: "小车",
  },
];
// 车型：1-大车，2-小车
export const enumerationCarType: objInfo = {
  1: "大车",
  2: "小车",
};

// 车型：1-大车，2-小车
export const enumeration_carType: objInfo = {
  0: "大车&小车",
  1: "大车",
  2: "小车",
};

export const enumerationCarTypeAll: objInfo[] = [
  {
    id: 0,
    nameCn: "大车&小车",
  },
  {
    id: 1,
    nameCn: "大车",
  },
  {
    id: 2,
    nameCn: "小车",
  },
];

// 小车：6、7、13、15
export const enumerationSeatNumListSmall: objInfo[] = [
  {
    id: 6,
    nameCn: "6座",
  },
  {
    id: 7,
    nameCn: "7座",
  },
  {
    id: 8,
    nameCn: "8座",
  },
  {
    id: 12,
    nameCn: "2台6座",
  },
  {
    id: 13,
    nameCn: "13座",
  },
  {
    id: 14,
    nameCn: "2台7座",
  },
  {
    id: 15,
    nameCn: "15座",
  },
];
// 大车：20、24、45、47、49、53、60
export const enumerationSeatNumListBig: objInfo[] = [
  {
    id: 20,
    nameCn: "20座",
  },
  {
    id: 24,
    nameCn: "24座",
  },
  {
    id: 45,
    nameCn: "45座",
  },
  {
    id: 47,
    nameCn: "47座",
  },
  {
    id: 49,
    nameCn: "49座",
  },
  {
    id: 51,
    nameCn: "51座",
  },
  {
    id: 53,
    nameCn: "53座",
  },
  {
    id: 60,
    nameCn: "60座",
  },
  {
    id: 98,
    nameCn: "2台49座",
  },
  {
    id: 147,
    nameCn: "3台49座",
  },
  {
    id: 196,
    nameCn: "4台49座",
  },
  {
    id: 245,
    nameCn: "5台49座",
  },
  {
    id: 294,
    nameCn: "6台49座",
  },
  {
    id: 343,
    nameCn: "7台49座",
  },
  {
    id: 392,
    nameCn: "8台49座",
  },
  {
    id: 441,
    nameCn: "9台49座",
  },
  {
    id: 490,
    nameCn: "10台49座",
  },
  {
    id: 1470,
    nameCn: "30台49座",
  },
];

export const passengerTypeOptions: objInfo[] = [
  {
    id: 1,
    nameCn: "成人票",
  },
  {
    id: 2,
    nameCn: "长者票",
  },
  {
    id: 3,
    nameCn: "小童票",
  },
  {
    id: 4,
    nameCn: "婴孩票",
  },
  {
    id: 5,
    nameCn: "学生票",
  },
];

export const enumeration_passenger_type_Standard: objInfo = {
  1: "成人票",
  2: "长者票(65岁以上)",
  3: "小童票(3-11岁)",
  4: "婴儿票(0-3岁)",
  5: "学生票",
};

// 标准价顺序表
export const passengerTypeOptionsStandard: objInfo[] = [
  {
    id: 1,
    nameCn: "成人票",
  },
  {
    id: 4,
    nameCn: "婴儿票(0-3岁)",
  },
  {
    id: 3,
    nameCn: "小童票(3-11岁)",
  },
  {
    id: 2,
    nameCn: "长者票(65岁以上)",
  },
  {
    id: 5,
    nameCn: "学生票",
  },
];
export const week_options_list = [
  {
    value: "0",
    label: "全选",
  },
  {
    value: "1",
    label: "周一",
  },
  {
    value: "2",
    label: "周二",
  },
  {
    value: "3",
    label: "周三",
  },
  {
    value: "4",
    label: "周四",
  },
  {
    value: "5",
    label: "周五",
  },
  {
    value: "6",
    label: "周六",
  },
  {
    value: "7",
    label: "周日",
  },
];

export const week_list: objInfo = {
  1: "星期一",
  2: "星期二",
  3: "星期三",
  4: "星期四",
  5: "星期五",
  6: "星期六",
  7: "星期日",
};
export const week_options_list1: objInfo[] = mapToList(week_list);

export const enumeration_certType_passengerEntry = [
  // 出票-乘客信息栏使用
  {
    value: 1,
    label: "内地身份证",
  },
  {
    value: 4,
    label: "香港身份证",
  },
  {
    value: 5,
    label: "澳门身份证",
  },
  {
    value: 7,
    label: "港澳通行证",
  },
  {
    value: 3,
    label: "港澳回乡证",
  },
  {
    value: 6,
    label: "台湾通行证",
  },
  {
    value: 2,
    label: "内地护照",
  },
  {
    value: 9,
    label: "香港护照",
  },
  {
    value: 8,
    label: "澳门护照",
  },
  {
    value: 10,
    label: "其他证件",
  }, // 10为其他证件，所有；与春林对接完毕。
];

// 选择车票状态（分页查询车票列表也状态下拉选择）
export const enumerationStatusOptions = [
  {
    id: 0,
    nameCn: "全部",
  },
  {
    id: 1,
    nameCn: "未乘车",
  },
  {
    id: 2,
    nameCn: "乘车中",
  },
  {
    id: 3,
    nameCn: "已使用",
  },
  {
    id: 4,
    nameCn: "已改签",
  },
  // {
  //   id: 5,
  //   nameCn: "已退票",
  // }, // 选择项不需要此
  {
    id: 6,
    nameCn: "已退票",
  },
  {
    id: 7,
    nameCn: "已过期",
  },
  {
    id: 8,
    nameCn: "已取消",
  },
  {
    id: 9,
    nameCn: "退票中",
  },
  {
    id: 11,
    nameCn: "部分已退款",
  },
  {
    id: 12,
    nameCn: "未取位",
  },
  //车票查询的列表open票已取位:13的状态不需要展示，因为已取位的变成了未乘车状态
  {
    id: 14,
    nameCn: "已停用",
  },
];

export const orgRangeTypeInfo = {
  1: "门市" as const,
  2: "代理" as const,
  3: "管理机构" as const,
  4: "操作员" as const,
};

export const enumerationStatus: objInfo = {
  1: "启用",
  0: "禁用",
};

export const enumStatus: objInfo = [
  {
    id: 1,
    nameCn: "启用",
  },
  {
    id: 0,
    nameCn: "禁用",
  },
];

// 班次销售可售状态：0-已生成不可售，1-可售
export const enumerationLineSaleStatus: objInfo = {
  0: "已生成不可售",
  1: "可售",
  2: "锁定",
  3: "已取消",
};

// 班次销售可售状态：选项
export const enumerationLineSaleStatus_options: objInfo[] = mapToList(
  enumerationLineSaleStatus
);
// 班次批量修改可售状态：0-不可售，1-可售
export const enumerationLineBatchSaleStatus: objInfo = {
  0: "不可售",
  1: "可售",
  2: "锁定",
};

// 班次销售可售状态：选项
export const enumerationLineBatchSaleStatus_options: objInfo[] = mapToList(
  enumerationLineBatchSaleStatus
);
export const enumeration_currencyType: objInfo = {
  1: "HK$",
  2: "RMB",
  3: "MOP$",
};
export const enumeration_currencyType_options = mapToList(
  enumeration_currencyType
);

// 打印要求特殊处理 = =。。
export const en_currencyType: objInfo = {
  1: "HKD",
  2: "RMB",
  3: "MOP$",
};

export const enumeration_currencyTypeName: objInfo = {
  1: "港币",
  2: "人民币",
  3: "澳门币",
};

export const enumeration_currencyTypeNameHK: objInfo = {
  1: "港幣",
  2: "人民幣",
  3: "澳門幣",
};

export const enumCurrencyType: objInfo[] = [
  {
    id: 1,
    nameCn: "港币",
  },
  {
    id: 2,
    nameCn: "人民币",
  },
  {
    id: 3,
    nameCn: "澳门币",
  },
];

export const enumYesOrNo: objInfo[] = [
  {
    id: 1,
    nameCn: "是",
  },
  {
    id: 0,
    nameCn: "否",
  },
];

export const enumeration_currencyTypeName_options = mapToList(
  enumeration_currencyTypeName
);

export const enumeration_passengerType: objInfo = {
  1: "成人票",
  2: "长者票",
  3: "小童票",
  4: "婴孩票",
  5: "学生票",
};

export const enumeration_passengerType2: objInfo = {
  1: "成人",
  2: "长者",
  3: "小童",
  4: "婴孩",
  5: "学生",
};

// 打印用
export const en_passType_CN: objInfo = {
  1: "成人",
  2: "长者",
  3: "小童",
  4: "婴孩",
  5: "学生",
}; // 去除了票字 =。=
// 打印用
export const en_passType_Hk: objInfo = {
  1: "成人",
  2: "長者",
  3: "小童",
  4: "嬰孩",
  5: "學生",
};
/** 手写票专用 */
export const en_passType_shouxie: objInfo = {
  1: "成人",
  2: "長者",
  3: "3-11 小童",
  4: "0-3岁 嬰孩",
  5: "學生",
};

export const enumeration_certTypeArr: objInfo = {
  1: "内地身份证",
  2: "内地护照",
  3: "港澳回乡证",
  4: "香港身份证",
  5: "澳门身份证",
  6: "台湾通行证",
  7: "港澳通行证",
  8: "澳门护照",
  9: "香港护照",
  10: "其他证件", // 注意，23年1月11日已和后端沟通 其他证件映射 0改为10，后端预计年后处理，特此注意此项。
};
/** 限制类型 */
export const enumeration_upDown = {
  0: "上下站",
  1: "上站",
  2: "下站",
} as const;

/** 限制类型list */
export const enumeration_upDown_options = mapToList(enumeration_upDown);

export const weekDays: weekDaysType = {
  "0": "日",
  "1": "一",
  "2": "二",
  "3": "三",
  "4": "四",
  "5": "五",
  "6": "六",
};

export const CapitalFigures = [
  "一",
  "二",
  "三",
  "四",
  "五",
  "六",
  "七",
  "八",
  "九",
  "十",
];
// 单程、
export const enumeration_tripType: objInfo = {
  1: "单程",
  2: "往返",
};

// 单程、往返
export const tripTypeList: objInfo[] = mapToList(enumeration_tripType);

export const enumeration_tripTypeHk: objInfo = {
  1: "單程",
  2: "往返",
};

export const enumeration_trip: objInfo = {
  0: "去程",
  1: "返程",
}; // 简繁体无区别

// 描述车票状态，描述用，下拉选择请求列表此不用
// open票，车票状态描述共用这一份
export const enumeration_ticketState_Showpiece: objInfo = {
  1: "未乘车", // 已出票（后端）
  2: "乘车中",
  3: "已使用", // 已乘车（后端）
  4: "已改签", // 中途改签（后端）
  5: "已改签", // 全程改签（后端）
  6: "已退票",
  7: "已过期",
  8: "已取消",
  9: "退款中",
  10: "未支付", // 待出票、出票中（后端）
  11: "部分已退款",
  12: "未取位",
  13: "已取位",
  14: "已停用",
};

/**
 * 车票类型-车票详情页
 */
export const enum_ticket_type_description: objInfo = {
  1: "普通车票",
  2: "open票",
  3: "代理库存票",
  4: "团体票",
  5: "VIP免票",
  6: "BB免票",
  7: "手写票", // 已作废
  8: "旅游产品车票",
  9: "系统外车票",
  10: "赠票",
  11: "自由票",
  12: "旅游产品车票",
};

/**
 * 车票类型-订单详情页
 * 巴士票车票类型：1-普通车票，2-改签车票，3-open兑换车票，4-open车票，5-团体票，6-代理买断车票，7-VIP免票，8-BB免票，9-手写票，10-系统外车票
 */
export const enum_order_ticket_type_description: objInfo = {
  1: "普通车票",
  2: "改签车票",
  3: "open兑换车票",
  4: "open车票",
  5: "团体票",
  6: "代理买断车票",
  7: "VIP免票",
  8: "BB免票",
  9: "手写票",
  10: "系统外车票",
};

/**
 * 车票大类-车票详情页
 */
export const enum_ticket_category_description: objInfo = {
  0: "电子票",
  1: "手写票",
};

export const enumeration_list_status: objInfo = {
  0: "全部",
  1: "已支付",
  3: "已取消",
};

export const trip_status_info: objInfo = {
  "1": "未发班",
  "2": "已发班",
  "3": "已取消",
  "4": "更改中",
  "5": "被合并",
  6: "被拆分",
};

/** -1-锁位，0-可售，1-选中，2-已售，3-预留，4-指定销售，5-已验票 */
export const seat_status_info: objInfo = {
  [-1]: "锁位",
  0: "可售",
  1: "选中",
  2: "已售",
  3: "预留",
  4: "指定",
  5: "已验票",
};

export const line_valid_type_status: objInfo = {
  0: "当班有效",
  1: "当日有效",
};
export const line_valid_type_status_list: objInfo[] = mapToList(
  line_valid_type_status
);

/**
 * 禁用于往返票
 */
export const disable_round_trip_status: objInfo = {
  1: "是",
  0: "否",
};
/**
 * 禁用于往返票
 */
export const disable_round_trip_status_list: objInfo[] = mapToList(
  disable_round_trip_status
);
/**
 * 禁止使用标准
 */
export const disable_round_trip_dict: objInfo[] = mapToList({
  0: "无",
  1: "全部",
  2: "单程",
  3: "双程",
});

/**
 * 禁用open票取位
 */
export const disable_open_ticket_status: objInfo = {
  1: "是",
  0: "否",
};
/**
 * 禁用open票取位
 */
export const disable_open_ticket_status_list: objInfo[] = mapToList(
  disable_open_ticket_status
);

/**
 * 是否加班
 */
export const over_time_line_status: objInfo = {
  1: "是",
  0: "否",
};
/**
 * 是否加班
 */
export const over_time_line_status_list: objInfo[] = mapToList(
  over_time_line_status
);

/**
 * 是否加价
 */
export const rise_price_status: objInfo = {
  1: "是",
  0: "否",
};
/**
 * 是否加价
 */
export const rise_price_status_list: objInfo[] = mapToList(rise_price_status);

/**
 * 免手续费退票
 */
export const free_refund_status: objInfo = {
  1: "是",
  0: "否",
};
/**
 * 免手续费退票
 */
export const free_refund_status_list: objInfo[] = mapToList(free_refund_status);

/**
 * 是否合营
 */
export const joint_venture_status: objInfo = {
  1: "是",
  0: "否",
};
/**
 * 是否合营
 */
export const joint_venture_status_list: objInfo[] =
  mapToList(joint_venture_status);
/**
 * 是否选择
 */
export const yes_or_no_status: objInfo = {
  0: "否",
  1: "是",
};
export const yes_or_no_status_list: objInfo[] = mapToList(yes_or_no_status);

export const enumeration_deposit_status: objInfo = {
  1: "待存款",
  2: "已存款",
};

export const enumeration_order_status: objInfo = {
  // 订单状态 - 订单查询（财务）
  1: "已完成" as const,
  2: "已超时" as const,
  3: "已取消" as const,
  10: "进行中" as const, // 后端（出票中）
};
export const enumeration_order_status_options: objInfo[] = mapToList(
  enumeration_order_status
);
/**
 * 订单类型 - 订单查询（财务）
 */
export const enumeration_order_type: objInfo = {
  1: "巴士购票订单",
  2: "巴士改签订单",
  3: "巴士退票订单",
  4: "open票销售订单",
  5: "open票取位订单",
  6: "巴士扫描改签订单",
  7: "代理库存订单",
  8: "巴士扫描取位订单",
  10: "行李票订单",
  // 11:'附加票订单（暂时先占用类型，基于多类型订单，实际数据库不会有单独的该类型）'
  // 12: "包车票订单",  // 包车票独立于订单、车票查询
  13: "团体票订单",
  14: "代理买断订单",
  15: "免费票",
  16: "手写票销售订单",
  17: "系统外订单",
  // 18:"行李票退票订单",
  // 25:"包车票退票订单",// 不显示
  19: "补价票订单",
  20: "补价票退票订单",
  100: "多类型订单",
};
// 注意：大于100，旅游产品，12、25包车票，其他为车票。

/**
 * 用于订单列表、车票列表，交易方式下拉
 */
export const enum_order_type_options = mapToList(enumeration_order_type);

export const enumeration_order_type_other: objInfo = {
  ...enumeration_order_type,
  12: "包车票订单", // 包车票独立于订单、车票查询，但是其它地方会一起出现。
};

export const enumeration_order_transactionType: objInfo = {
  // 订单交易类型 - 订单查询（财务）
  0: "全部",
  1: "支付订单",
  2: "退款订单",
};

export const enum_query_sourceChannel: objInfo = {
  // 销售来源渠道
  0: "全部",
  1: "门市",
  2: "代理",
  3: "验票APP", // 后端（APP门市）
  4: "代理API",
  5: "代理 APP",
};

export const enum_query_ticketType = {
  0: "全部",
  1: "行李票",
  2: "补价票",
} as const;

export const enum_query_ticketType_options = mapToList(enum_query_ticketType);

export const enum_status: objInfo = {
  0: "全部",
  1: "启用",
  2: "禁用",
};
export const enum_status_options = mapToList(enum_status);

export const enum_agent_type: objInfo = {
  1: "总代理",
  2: "子代理",
};

export const enum_agent_type_options = mapToList(enum_agent_type);

export const enum_agent_price_strategy: objInfo = {
  // 价格策略 - 代理
  1: "优惠百分比",
  2: "固定扣减",
  3: "指定金额",
};

export const enum_agent_description_cash_changes: objInfo = {
  // 现金变动描述
  1: "分配",
  2: "子代理",
};

// open票订单状态
export const enum_open_status_options: objInfo = [
  // open-list
  {
    id: 0,
    nameCn: "全部",
  },
  {
    id: 7,
    nameCn: "已过期",
  },
  {
    id: 12,
    nameCn: "未取位",
  },
  {
    id: 13,
    nameCn: "已取位",
  },
];

// 销售渠道
export const enum_open_source_channel_options: objInfo = [
  {
    id: 1,
    nameCn: "门市",
  },
  {
    id: 2,
    nameCn: "代理",
  },
  {
    id: 3,
    nameCn: "验票app", // 后端（APP门市）
  },
  {
    id: 4,
    nameCn: "代理API",
  },
  {
    id: 5,
    nameCn: "代理APP",
  },
];

/** 行李票销售渠道 */
export const enum_package_source_channel: objInfo = {
  0: "门市",
  1: "验票app",
};

/** 行李票销售渠道List */
export const enum_package_source_channel_options: objInfo[] = mapToList(
  enum_package_source_channel
);

// 售票订单状态
export const enum_order_status_options: objInfo = [
  {
    id: 10,
    nameCn: "进行中",
  },
  {
    id: 1,
    nameCn: "已完成",
  },
  {
    id: 3,
    nameCn: "已取消",
  },
];

export const enum_transaction_type_options: objInfo = [
  {
    id: 1,
    nameCn: "支付订单",
  },
  {
    id: 2,
    nameCn: "退款订单",
  },
];

export const enumeratioCompanyTypeList: objInfo[] = [
  {
    id: 0,
    nameCn: "集团下属",
  },
  {
    id: 1,
    nameCn: "其他公司",
  },
];
export const enumeratio_company_type: objInfo = {
  0: "集团下属",
  1: "其他公司",
};

export const enumeratioCompanyLevelTypeList: objInfo[] = [
  {
    id: 0,
    nameCn: "抬头公司",
  },
  {
    id: 1,
    nameCn: "运营公司",
  },
];
export const enumeratio_company_levelType: objInfo = {
  0: "抬头公司",
  1: "运营公司",
};

export const enumeratioSpecialTicketList: objInfo[] = [
  {
    id: 0,
    nameCn: "行李票",
  },
  {
    id: 1,
    nameCn: "附加票",
  },
  // {
  //   id: 2,
  //   nameCn: "现金券",
  // },
];
export const enumeratio_special_ticket: objInfo = {
  0: "行李票",
  1: "附加票",
  2: "现金券",
};

export const enumeratioSpecialTicketPriceType: objInfo[] = [
  {
    id: 0,
    nameCn: "固定金额",
  },
  {
    id: 1,
    nameCn: "按照比率(%)",
  },
];
export const enumeratio_special_ticket_price_type: objInfo = {
  0: "固定金额",
  1: "按照比率(%)",
};

//
export const enumeratioTicketCategory: objInfo[] = [
  {
    id: 1,
    nameCn: "生成订单",
  },
  {
    id: 2,
    nameCn: "支付完成",
  },
  {
    id: 3,
    nameCn: "验票",
  },
  {
    id: 4,
    nameCn: "订单取消",
  },
  {
    id: 5,
    nameCn: "改签",
  },
  {
    id: 6,
    nameCn: "退票",
  },
  {
    id: 7,
    nameCn: "open票取位",
  },
  {
    id: 8,
    nameCn: "打印",
  },
  {
    id: 9,
    nameCn: "车票过期",
  },
  {
    id: 10,
    nameCn: "库存票增值",
  },
  {
    id: 11,
    nameCn: "库存票分配",
  },
  {
    id: 12,
    nameCn: "库存票回收",
  },
  {
    id: 13,
    nameCn: "库存票转移",
  },
  {
    id: 14,
    nameCn: "通融改签",
  },
  {
    id: 15,
    nameCn: "退票打印",
  },
];

export const enum_discountType_type: objInfo = {
  1: "优惠",
  2: "加价",
  3: "加班车",
  4: "其他",
};
export const enum_discountType: objInfo = [
  {
    id: 1,
    nameCn: "优惠",
  },
  {
    id: 2,
    nameCn: "加价",
  },
  {
    id: 3,
    nameCn: "加班车",
  },
  {
    id: 4,
    nameCn: "其他",
  },
];
export const enumeratio_ticket_category: objInfo = {
  1: "生成订单",
  2: "支付完成",
  3: "验票",
  4: "订单取消",
  5: "改签",
  6: "退票",
  7: "open票取位",
  8: "车票打印",
  9: "车票过期",
  10: "库存票增值",
  11: "库存票分配",
  12: "库存票回收",
  13: "库存票转移",
  14: "通融改签",
  15: "退票打印",
  16: "修改打印状态",
  17: "消位",
  18: "扫错更正",
  19: "open票延期",
  20: "手写票增值",
  21: "手写票延期",
  22: "车票禁用",
  23: "车票启用",
  24: "手写票转移",
  25: "手写票申请",
  26: "手写票审批",
  27: "消除打印",
  28: "补打",
};

// 退款打印支付渠道
export const print_refund_method_describe: objInfo = {
  1: "现金",
  100: "现金、原支付渠道退回",
};

export const print_refund_method_describeHk: objInfo = {
  1: "現金",
  100: "現金、原支付渠道退回",
};

/**
 * 修改打印原因
 */
export const print_feedback: objInfo = {
  1: "打印机不出纸",
  2: "打印不清晰，车票作废",
  3: "系统问题导致未成功打印",
  4: "网络问题导致无法出票",
  5: "其他",
};
export const print_feedback_options: objInfo[] = mapToList(print_feedback);

export const pagination_layout_jumper =
  "total, sizes, prev, pager, next, jumper";

export const pagination_layout_common = "total, sizes, prev, pager, next";

// 预留票状态
export const enum_book_ticket_status: objInfo = {
  0: "预留中",
  1: "已取消",
  2: "已处理",
  3: "已过期",
};

// 预留票类型
export const enum_book_ticket_time: objInfo = {
  0: "预留2小时",
  1: "预留12小时",
  2: "预留至发车前24小时",
  3: "不限时预留",
};

// 预留票状态
export const enum_book_ticket_options: objInfo[] = [
  {
    id: 0,
    nameCn: "预留中",
  },
  {
    id: 1,
    nameCn: "已取消",
  },
  {
    id: 2,
    nameCn: "已处理",
  },
  {
    id: 3,
    nameCn: "已过期",
  },
];

export const enumeration_certType_options = mapToList(enumeration_certTypeArr);

// 预统计路线类别
export const enum_statistical_types: objInfo = {
  0: "财务统计路线",
  1: "票务统计路线",
};
// 预统计路线类别-options
export const enum_statistical_options = mapToList(enum_statistical_types);

// 预审单商品类型
export const report_goods_types: objInfo = {
  1: "巴士票",
  2: "行李票",
  3: "包车票",
  4: "旅游产品",
  5: "补价票",
};
export const report_goods_type_options = mapToList(report_goods_types);

export const yushen_audit_status: objInfo = {
  1: "未通过",
  2: "已通过",
};

export const yushen_audit_status_options = mapToList(yushen_audit_status);

export const yushen_repayment_status: objInfo = {
  1: "未还款",
  2: "已还款",
};

export const yushen_repayment_status_options = mapToList(
  yushen_repayment_status
);

// 基础路线方向
export const route_direction_status: objInfo = {
  1: "南行",
  2: "北行",
};
export const route_direction_option_list = mapToList(route_direction_status);

// 基础路线类型
export const route_type_status: objInfo = {
  1: "内运",
  2: "穿梭",
  3: "长途",
};
export const route_type_optin_list = mapToList(route_type_status);
// 班次座位明细 - 操作类型；专用
export const shift_seat_details_category: objInfo = {
  1: "销售",
  2: "取位",
  3: "预留",
  4: "取消预留",
  5: "消位",
  6: "退票",
  7: "改签",
  8: "通融改签",
};

// 结算报表-退票类型
export const refund_type_status: objInfo = {
  0: "非当月销售，当月退票",
  1: "当月销售，当月退票",
};
export const refund_type_optin_list = mapToList(refund_type_status);

export const enum_refund_settlement_options: objInfo[] = [
  {
    id: 1,
    nameCn: "门市",
  },
  {
    id: 2,
    nameCn: "代理预付款账户",
  },
  {
    id: 3,
    nameCn: "代理月结账户",
  },
  {
    id: 4,
    nameCn: "代理库存票账户",
  },
];

export const enum_record_type_options: objInfo[] = [
  {
    id: 1,
    nameCn: "正常退票",
  },
  {
    id: 2,
    nameCn: "改签记的退票",
  },
  {
    id: 3,
    nameCn: "取位记的退票",
  },
];

// 订单归属
export const orderOwner_type: objInfo = {
  1: "自营",
  2: "澳方合营",
};
export const orderOwner_type_options = mapToList(orderOwner_type);

// 存款单结算类型
export const deposit_settle_type: objInfo = {
  1: "非预付款",
  2: "预付款",
};
export const deposit_settle_type_options = mapToList(deposit_settle_type);

// 预审单结算类型
export const yushen_settle_type: objInfo = {
  // 1: "门市",
  // 2: "预付款",
  3: "月结", // 只显示这两种即可
  4: "买断",
};
export const yushen_settle_type_options = mapToList(yushen_settle_type);

// 结算类型
export const yushen_settle_type2: objInfo = {
  1: "门市",
  2: "预付款",
  3: "月结", // 显示这四种
  4: "买断",
};
export const yushen_settle_type_options2 = mapToList(yushen_settle_type2);

// 车票详情结算类型
export const ticket_detail_settle_type: objInfo = {
  1: "职员",
  2: "预付款",
  3: "月结", // 显示这四种
  4: "买断",
};
export const ticket_detail_settle_type_options = mapToList(
  ticket_detail_settle_type
);

export const month_settle_type: objInfo = {
  1: "销售",
  2: "取位",
};
export const msg_org_type: objInfo = {
  1: "所有管理机构",
  2: "所有门市",
  3: "所有代理",
  4: "指定单位",
};

// 现金券状态
export const marketing_coupon_type: objInfo = {
  0: "待核销",
  1: "已核销",
  2: "已过期",
  3: "已作废",
};
export const marketing_coupon_type_options = mapToList(marketing_coupon_type);

//手写票状态
export const handwrite_ticket_status: objInfo = {
  0: "申请中",
  1: "已通过",
  2: "未通过",
};

export const handwrite_ticket_options = mapToList(handwrite_ticket_status);

// 交易方式渠道
export const source_channels_type: objInfo = {
  1: "门店",
  2: "验票APP",
  3: "代理B门户",
  5: "财务",
};
export const source_channels_type_options = mapToList(source_channels_type);

export const finance_month_settle_type: objInfo = {
  1: "结算中",
  2: "已完成",
};
export const finance_month_settle_type_options = mapToList(
  finance_month_settle_type
);

// 城市类型：1-香港，2-澳门，3-内地
export const city_areaCode_settle_type: objInfo = {
  1: "852",
  2: "853",
  3: "86",
};

export const agency_settle_type: objInfo = {
  1: "门市代理",
  2: "国内汽车站",
  3: "商务机构",
  4: "酒店",
  5: "旅行社",
  6: "宾馆",
};
export const agency_settle_type_options = mapToList(agency_settle_type);

// 手写票打印状态
export const enumeration_hrticket_printState: objInfo = {
  0: "未打印",
  1: "已打印",
};
// 手写票车票状态
export const enumeration_hrticketState: objInfo = {
  10: "未出票",
  1: "已出票",
  2: "乘车中",
  3: "已乘车",
  4: "退票中",
  5: "已退票",
  6: "已过期",
  7: "已取消",
  8: "已改签",
  9: "已作废",
  11: "已停用",
};
export const enumeration_hrticketState_options = mapToList(
  enumeration_hrticketState
);

//验证方式
export const enum_verify_type_options: objInfo = {
  0: "明文密码",
  1: "加密签名",
};

//地图类型
export const enum_map_type_options: objInfo = {
  0: "谷歌地图",
  1: "腾讯地图",
  2: "百度地图",
};

//用户白名单类型
export const enum_white_type_options: objInfo = {
  0: "用户白名单",
  1: "代理白名单",
};

/**
 * 交易记录查询-列表交易类型
 */
export const enumeration_order_types: objInfo = {
  1: "巴士购票订单",
  2: "巴士改签订单",
  3: "巴士退票订单",
  4: "open票销售订单",
  5: "open票取位订单",
  6: "巴士扫描改签订单",
  8: "巴士扫描取位订单",
  7: "代理库存订单",
  10: "行李票订单",
  12: "包车票订单",
  13: "团体票订单",
  14: "买断订单",
  15: "免费票订单",
  16: "手写票销售订单",
  17: "系统外订单",
  18: "自有旅游产品订单",
  19: "API旅游产品订单",
  20: "旅游产品退款订单",
  100: "多类型订单",
};

export const enumeration_order_types_options: objInfo[] = mapToList(
  enumeration_order_types
);

// 报表订单类型 - 用于财务报表查询
export const enumeration_report_order_types = {
  1: "巴士购票订单",
  2: "巴士改签订单",
  3: "巴士退票订单",
  4: "open票销售订单",
  5: "open票取位订单",
  6: "巴士扫描改签订单",
  7: "代理库存订单",
  10: "行李票订单",
  12: "包车票订单",
  13: "团体票订单",
  14: "代理买断订单",
  15: "免费票",
  16: "手写票销售订单",
} as const;

// 报表订单类型选项列表
export const enumeration_report_order_types_options = mapToList(
  enumeration_report_order_types
);
// 打印状态
export const print_status: objInfo = {
  0: "未打印",
  1: "已打印",
};

export const print_status_options: objInfo[] = mapToList(print_status);
//产品类型
export const enum_product_type_options: objInfo = {
  1: "八达通",
  2: "电话卡",
  3: "酒店",
  4: "保险",
  5: "景点门票",
  6: "实物礼品",
};
export const enum_product_type_optionss = mapToList(enum_product_type_options);
//有效期类型
export const enum_date_type_options: objInfo = {
  1: "永久有效",
  2: "有效日期",
  3: "有效天数",
};
//操作类型
export const enum_category_type_options: objInfo = {
  1: "生成订单",
  2: "支付完成",
  3: "退款",
};

// 座位列表数组
export const all_seat_template: Record<number, number[]> = {
  6: [1, 0, 0, 2, 0, 3, 4, 5, 6],
  7: [1, 2, 0, 3, 4, 5, 6, 7],
  8: [1, 2, 3, 4, 5, 6, 7, 8],
  12: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  13: [1, 0, 2, 3, 0, 4, 5, 0, 6, 7, 0, 8, 9, 0, 10, 11, 12, 13],
  14: [1, 2, 0, 3, 4, 5, 6, 7, 8, 9, 0, 10, 11, 12, 13, 14],
  15: [1, 2, 0, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
  20: [
    1, 0, 2, 3, 0, 0, 4, 5, 6, 0, 7, 8, 9, 0, 10, 11, 12, 0, 13, 14, 15, 0, 16,
    17, 18, 0, 19, 20,
  ],
  24: [
    1, 0, 2, 3, 0, 0, 4, 5, 6, 0, 7, 8, 9, 0, 10, 11, 12, 0, 13, 14, 15, 0, 16,
    17, 18, 0, 19, 20, 21, 22, 23, 24,
  ],
  45: [
    1, 2, 0, 3, 4, 5, 6, 0, 7, 8, 9, 10, 0, 11, 12, 13, 14, 0, 15, 16, 17, 18,
    0, 19, 20, 21, 22, 0, 23, 24, 25, 26, 0, 0, 0, 27, 28, 0, 29, 30, 31, 32, 0,
    33, 34, 35, 36, 0, 37, 38, 39, 40, 0, 0, 0, 41, 42, 43, 44, 45,
  ],
  47: [
    1, 2, 0, 3, 4, 5, 6, 0, 7, 8, 9, 10, 0, 11, 12, 13, 14, 0, 15, 16, 17, 18,
    0, 19, 20, 21, 22, 0, 23, 24, 25, 26, 0, 27, 28, 29, 30, 0, 0, 0, 31, 32, 0,
    33, 34, 35, 36, 0, 37, 38, 39, 40, 0, 41, 42, 43, 44, 45, 46, 47,
  ],
  49: generate49SeatTemplate(1),
  51: [
    1, 2, 0, 3, 4, 5, 6, 0, 7, 8, 9, 10, 0, 11, 12, 13, 14, 0, 15, 16, 17, 18,
    0, 19, 20, 21, 22, 0, 23, 24, 25, 26, 0, 27, 28, 29, 30, 0, 31, 32, 33, 34,
    0, 35, 36, 37, 38, 0, 39, 40, 41, 42, 0, 43, 44, 45, 46, 0, 47, 48, 49, 50,
    0, 51, 0,
  ],
  53: [
    1, 2, 0, 3, 4, 5, 6, 0, 7, 8, 9, 10, 0, 11, 12, 13, 14, 0, 15, 16, 17, 18,
    0, 19, 20, 21, 22, 0, 23, 24, 25, 26, 0, 27, 28, 29, 30, 0, 31, 32, 33, 34,
    0, 35, 36, 37, 38, 0, 39, 40, 41, 42, 0, 43, 44, 45, 46, 0, 47, 48, 49, 50,
    51, 52, 53,
  ],
  60: [
    1, 2, 0, 3, 4, 5, 6, 0, 7, 8, 9, 10, 0, 11, 12, 13, 14, 0, 15, 16, 17, 18,
    0, 19, 20, 21, 22, 0, 23, 24, 25, 26, 0, 27, 28, 29, 30, 0, 31, 32, 33, 34,
    0, 0, 0, 35, 36, 0, 0, 0, 39, 40, 0, 37, 38, 43, 44, 0, 41, 42, 47, 48, 0,
    45, 46, 51, 52, 0, 49, 50, 55, 56, 0, 53, 54, 59, 60, 0, 57, 58,
  ],
  98: generate49SeatTemplate(2, true),
  147: generate49SeatTemplate(3, true),
  196: generate49SeatTemplate(4, true),
  245: generate49SeatTemplate2(5),
  294: generate49SeatTemplate2(6),
  343: generate49SeatTemplate(7, true),
  392: generate49SeatTemplate(8, true),
  441: generate49SeatTemplate(9, true),
  490: generate49SeatTemplate(10, true),
  1470: generate49SeatTemplate(30),
};

export type SeatNumType = keyof typeof all_seat_template;

// 单位渠道区分，目前只设计这
export const unit_channel_status: objInfo = {
  0: "全部实时门市",
  1: "全部实时代理",
};

export const unit_channel_status_options: objInfo[] =
  mapToList(unit_channel_status);

export const extends_company_status: objInfo = {
  1: "是",
  0: "否",
};

// 单位渠道区分，目前只设计这
export const product_enum_status: objInfo = {
  1: "启用",
  2: "禁用",
};
export const product_enum_status_options = mapToList(product_enum_status);

//房源确定情况
export const housing_availability: objInfo = {
  0: "等候确认",
  1: "立即确认",
};

export const housing_availability_options = mapToList(housing_availability);

//床型
export const bed_ype: objInfo = {
  0: "双床房",
  1: "单床房",
  2: "家庭房",
  3: "四人房",
  4: "标间",
  5: "大床房",
  6: "特大床房",
  7: "3床房",
  8: "套房",
  9: "亲子房",
  10: "圆床房",
  11: "双人房",
  12: "大/双床",
  13: "大床+小床",
  14: "三人间",
};

export const bed_ype_options = mapToList(bed_ype);

//是否含早餐
export const is_breakfast: objInfo = {
  0: "不含早",
  1: "单早",
  2: "双早",
  3: "含三早",
  4: "2大1小自助早餐",
  5: "含4早",
  6: "2大2小早餐",
  7: "含5早",
  8: "含6早",
};

export const is_breakfast_options = mapToList(is_breakfast);
//旅游酒店产品类型
export const types_tourism_products: objInfo = {
  16: "迪士尼",
  27: "长隆",
  17: "融创",
};

export const types_of_tourism_products_options = mapToList(
  types_tourism_products
);
//旅游产品是否允许退票
export const products_refund_ticket: objInfo = {
  0: "不可退",
  1: "可退",
};

export const products_refund_ticket_options = mapToList(products_refund_ticket);

export const products_enumeration_status: objInfo = {
  1: "启用",
  2: "禁用",
};
export const products_enumeration_status_options = mapToList(
  products_enumeration_status
);

//旅游产品新增类别
export const category_tourism_products: objInfo = {
  1: "车票",
  2: "自有产品",
  3: "API门票",
  4: "酒店产品",
};
export const category_tourism_products_options = mapToList(
  category_tourism_products
);
//旅游产品订单类别
export const category_tourism_order_products: objInfo = {
  1: "车票",
  2: "自有产品",
  3: "API门票",
  4: "酒店产品",
  5: "产品打包套票",
};
export const category_tourism_order_options = mapToList(
  category_tourism_order_products
);
//旅游产品订单类别
export const category_tourism_order_status: objInfo = {
  1: "已完成",
  2: "已超时",
  3: "已取消",
  10: "未出票",
};
export const category_tourism_order_status_options = mapToList(
  category_tourism_order_status
);
/**
 * 旅游是否可出售API门票
 */
export const isSellAPItieckt: objInfo = {
  1: "是",
  0: "否",
};
/**
 * 是否可出售门票
 */
export const isSellAPItieckt_list: objInfo[] = mapToList(isSellAPItieckt);

//旅游融创产品
export const API_tour_products: objInfo = {
  1: "门票",
  2: "套票",
};

export const API_tour_products_options = mapToList(API_tour_products);

//旅游产品手机区号
export const API_tour_productsPhnoe: objInfo = {
  1: "86",
  2: "853",
  3: "852",
};
/**
 * 是否自动预审单/还款
 */
export const create_type_status: objInfo = {
  1: "否",
  2: "是",
};

export const create_type_options = mapToList(create_type_status);

/**
 * 交易状态
 */
export const order_status: objInfo = {
  1: "待交易",
  2: "交易中",
  3: "交易成功",
  4: "交易失败",
};

export const API_tour_enumeration_order_status: objInfo = {
  // 订单状态 - 订单查询（财务）
  1: "已售出",
  2: "已退",
  3: "退款中",
  4: "已取消",
  5: "已超时",
  6: "已核销",
  10: "支付中",
  11: "待确认状态",
};
export const API_tour_enumeration_order_status_options = mapToList(
  API_tour_enumeration_order_status
);

/**
 * POS操作日志类型枚举
 */
export const BocPosOperateLogTypeEnum: objInfo = {
  1: "POS机操作",
  2: "打印操作",
} as const;

/**
 * POS操作日志类型选项列表
 */
export const BocPosOperateLogTypeEnum_options = mapToList(
  BocPosOperateLogTypeEnum
);
//旅游产品交易类型
export const pay_type_order_products: objInfo = {
  1: "支付订单",
  2: "退款订单",
};
export const pay_type_order_products_options = mapToList(
  pay_type_order_products
);
export const agency_scope_discount_types: objInfo = {
  1: "同上级代理",
  2: "自主设置",
};
//旅游产品库存类型
export const Inventory_type_products: objInfo = {
  1: "总部库存",
  2: "管理机构",
  3: "代理",
};
export const Inventory_type_products_options = mapToList(
  Inventory_type_products
);
//旅游产品报表类别
export const tourism_products_report_type = {
  1: "按使用",
  2: "按销售",
  3: "买断",
  4: "预付款",
} as const;
export const tourism_products_report_type_options = mapToList(
  tourism_products_report_type
);

// 供应商结算类别
export const supplier_settle_type = {
  1: "按使用",
  2: "按销售",
  3: "买断", // 显示这四种
  4: "预付款",
} as const;
export const supplier_settle_type_options = mapToList(supplier_settle_type);
//旅游产品订单类型
export const tourism_products_order_type = {
  101: "旅游产品退款订单",
  102: "旅游产品套票订单",
  103: "旅游产品自有产品订单",
  104: "旅游产品酒店订单",
  105: "旅游产品迪士尼订单",
  106: "旅游产品长隆订单",
  107: "旅游产品融创订单",
  108: "旅游产品华发订单",
  109: "旅游产品API酒店NCNB订单",
} as const;
export const tourism_products_order_type_options = mapToList(
  tourism_products_order_type
);

// 包车票状态
export const charter_status_type = {
  1: "已完成",
  2: "已退票",
} as const;

/**
 * 后台退票手续费类型 1-比例，2-固定金额 默认按比例
 */
export const enum_refund_fee_type: objInfo = {
  1: "比例",
  2: "固定金额",
};
/* 自有产品页面销售库存 */
export const stockType_List = {
  2: "总部库存",
  3: "机构库存",
} as const;
export const stockType_List_options = mapToList(stockType_List);

/* 核销类型 */
export const verifyType = {
  0: "无需核销",
  1: "供应商核销",
} as const;
export const verifyType_options = mapToList(verifyType);

/* 行李票车票车票状态 */
export const baggage_status = {
  0: "未出票",
  1: "已出票",
  2: "已退票",
} as const;

/** 库存票号状态 */
export const enumeration_statusType = {
  0: "未使用",
  1: "已使用",
  2: "已禁用",
} as const;
export const enumeration_status_List_options = mapToList(
  enumeration_statusType
);

// ============================================
// 显示座位号相关枚举（已优化 ✅）
// ============================================

/**
 * 短信/样式显示座位号枚举
 * @description 控制是否在短信和样式中显示座位号
 * @改造状态 已优化 ✅
 */
export const enumIsShowSeatNo = {
  1: "是",
  0: "否",
} as const;

/** 显示座位号选项类型 (1-是, 0-否) */
export type ShowSeatNoType = keyof typeof enumIsShowSeatNo;

/** 显示座位号文本类型 */
export type ShowSeatNoText = (typeof enumIsShowSeatNo)[ShowSeatNoType];

/**
 * 短信/样式显示座位号选项列表
 * @description 用于下拉选择等场景
 * @改造状态 已优化 ✅
 */
export const ShowSeatNoOption = [
  {
    id: 1,
    nameCn: "是",
  },
  {
    id: 0,
    nameCn: "否",
  },
] as const;

/** 显示座位号选项类型 */
export type ShowSeatNoOptionType = typeof ShowSeatNoOption;

/** 显示座位号选项项类型 */
export type ShowSeatNoOptionItem = ShowSeatNoOptionType[number];

/**
 * 发送短信枚举
 * @description 控制是否发送短信
 * @改造状态 已优化 ✅
 */
export const send_msg_status = {
  1: "是",
  0: "否",
} as const;

/** 发送短信选项类型 (1-是, 0-否) */
export type SendMsgType = keyof typeof send_msg_status;

/** 发送短信文本类型 */
export type SendMsgText = (typeof send_msg_status)[SendMsgType];

// ============================================
// 多台49座座位枚举生成函数（新增 ✅）
// ============================================

/**
 * 生成多台49座的座位枚举数组
 * @description 基于单台49座的模版，生成指定台数的座位排列数组
 * @param num 巴士台数，必须大于0; isSplit: 是否添加车辆间的分隔符
 * @returns 座位号数组，0表示过道或空位
 * @author 根据49座模版扩展生成
 * @date 2026-01-21
 */
export function generate49SeatTemplate(
  num: number,
  isSplit?: boolean
): number[] {
  // 参数验证
  if (!num || num <= 0 || !Number.isInteger(num)) {
    throw new Error("巴士台数必须是大于0的整数");
  }

  // 单台49座的基础模版
  const single49SeatTemplate: number[] = [
    1, 2, 0, 3, 4, 5, 6, 0, 7, 8, 9, 10, 0, 11, 12, 13, 14, 0, 15, 16, 17, 18,
    0, 19, 20, 21, 22, 0, 23, 24, 25, 26, 0, 27, 28, 29, 30, 0, 31, 32, 33, 34,
    0, 35, 36, 37, 38, 0, 39, 40, 41, 42, 0, 43, 44, 45, 46, 47, 48, 49,
  ];

  // 生成多台车的座位数组
  const result: number[] = [];

  for (let busIndex = 0; busIndex < num; busIndex++) {
    // 计算当前台车的座位号偏移量（每台车49个座位）
    const seatOffset = busIndex * 49;

    // 为当前台车生成座位数组
    const currentBusSeats = single49SeatTemplate.map((seat) => {
      // 0表示过道或空位，保持不变
      if (seat === 0) {
        return 0;
      }
      // 其他座位号加上偏移量
      return seat + seatOffset;
    });

    // 将当前台车的座位添加到结果数组
    result.push(...currentBusSeats);

    // 如果不是最后一台车，添加车辆间的分隔符（5个0表示换车间隔）
    if (busIndex < num - 1 && isSplit) {
      result.push(0, 0, 0, 0, 0);
    }
  }

  return result;
}

/**
 * 生成多台49座的座位枚举数组-2
 * @description 基于单台49座的模版，生成指定台数的座位排列数组
 * @param num 巴士台数，必须大于0;
 * @returns 座位号数组，0表示过道或空位
 * @author 根据49座模版扩展生成
 * @date 2026-01-21
 */
export function generate49SeatTemplate2(num: number): number[] {
  // 参数验证
  if (!num || num <= 1 || !Number.isInteger(num)) {
    throw new Error("巴士台数必须是大于1的整数");
  }

  // 单台49座的基础模版
  const single49SeatTemplate: number[] = [
    1, 2, 0, 3, 4, 5, 6, 0, 8, 7, 9, 10, 0, 12, 11, 13, 14, 0, 16, 15, 17, 18,
    0, 20, 19, 21, 22, 0, 24, 23, 25, 26, 0, 0, 0, 27, 28, 0, 30, 29, 31, 32, 0,
    34, 33, 35, 36, 0, 38, 37, 39, 40, 0, 0, 0, 41, 42, 0, 44, 43, 45, 46, 47,
    48, 49,
  ];

  // 生成多台车的座位数组-第一台特殊处理
  const result: number[] = [
    1, 2, 0, 4, 3, 5, 6, 0, 8, 7, 9, 10, 0, 12, 11, 13, 14, 0, 16, 15, 17, 18,
    0, 20, 19, 21, 22, 0, 24, 23, 25, 26, 0, 0, 0, 27, 28, 0, 30, 29, 31, 32, 0,
    34, 33, 35, 36, 0, 38, 37, 39, 40, 0, 0, 0, 41, 42, 0, 44, 43, 45, 46, 49,
    48, 47,
  ];

  for (let busIndex = 1; busIndex < num; busIndex++) {
    // 计算当前台车的座位号偏移量（每台车49个座位）
    const seatOffset = busIndex * 49;

    // 为当前台车生成座位数组
    const currentBusSeats = single49SeatTemplate.map((seat) => {
      // 0表示过道或空位，保持不变
      if (seat === 0) {
        return 0;
      }
      // 其他座位号加上偏移量
      return seat + seatOffset;
    });

    // 将当前台车的座位添加到结果数组
    result.push(...currentBusSeats);
  }

  return result;
}

// 现金券适用范围
export const coupon_rule_scope_type = {
  0: "站点",
  1: "路线",
  2: "旅游产品",
} as const;
export const coupon_rule_scope_type_options = mapToList(coupon_rule_scope_type);
// 班次余位预警状态，todo等待后端调整字段
export const enum_seat_alarm_status: objInfo = {
  0: "未处理",
  1: "已处理",
  2: "已过期",
};
export const enum_seat_alarm_status_options = mapToList(enum_seat_alarm_status);

// 粤港消息监控-方向
export const ygNotifyDirectionMap: Record<number, string> = {
  1: "KC->粤港",
  2: "粤港->KC",
};
export const ygNotifyDirectionOptions = mapToList(ygNotifyDirectionMap);

// 粤港消息监控-业务类型
export const ygNotifyBizTypeMap: Record<number, string> = {
  0: "其他路线",
  1: "销售",
  2: "改签",
  3: "取位",
  4: "退票",
  5: "消位",
};
export const ygNotifyBizTypeOptions = mapToList(ygNotifyBizTypeMap);

// 粤港消息监控-状态
export const ygNotifyStateMap: Record<number, string> = {
  0: "待处理",
  1: "成功",
  2: "失败",
};
export const ygNotifyStateOptions = mapToList(ygNotifyStateMap);
